import { Lang, Team } from "@brg/api";
import { convertJsonToString } from "./convertJsonToString";

export const getChannelName = (t: Team, lang: string) => {
    const mainName = Lang(t?.name, lang);
    const lmsGroupTitle = convertJsonToString(t?.additionalInfo?.lmsGroupTitle || '');
    const lmsGroupName= convertJsonToString(t?.additionalInfo?.lmsGroupName || '');
    const finalName = !!lmsGroupTitle?.length ? lmsGroupTitle : lmsGroupName;
    const groupName = Lang(finalName, lang)


    return `${mainName} ${groupName}`
} import { Lang, Team } from "@brg/api";
import { convertJsonToString } from "./convertJsonToString";

export const getChannelName = (t: Team, lang: string) => {
    const mainName = Lang(t?.name, lang);
    const lmsGroupTitle = convertJsonToString(t?.additionalInfo?.lmsGroupTitle || '');
    const lmsGroupName= convertJsonToString(t?.additionalInfo?.lmsGroupName || '');
    const finalName = !!lmsGroupTitle?.length ? lmsGroupTitle : lmsGroupName;
    const groupName = Lang(finalName, lang)


    return `${mainName} ${groupName}`
} 